let usbKeyErrEn = {
    100: {
        descArgs: 'The data is incorrect.',
        reasonArgs: 'The data is incorrect.',
        detailArgs: 'The data is incorrect.',
        adviceArgs: 'Check the parameters.',
    },
    152: {
        descArgs: 'The specified PIN has expired.',
        reasonArgs: 'The specified PIN has expired.',
        detailArgs: 'The specified PIN has expired.',
        adviceArgs: '',
    },
    153: {
        descArgs: 'The specified token does not support parallel sessions.',
        reasonArgs: 'The specified token does not support parallel sessions.',
        detailArgs: 'The specified token does not support parallel sessions.',
        adviceArgs: '',
    },
    500: {
        descArgs: 'Service processing.',
        reasonArgs: 'Service processing.',
        detailArgs: 'Service processing.',
        adviceArgs: 'Please try again later.',
    },
    3489660928: {
        descArgs: 'Service request timed out.',
        reasonArgs: 'Service request timed out.',
        detailArgs: 'Service request timed out.',
        adviceArgs: 'Check the network or whether the driver is installed.',
    },
    3489660929: {
        descArgs: 'No USB key found. Check whether you have installed the certificate maker.',
        reasonArgs: 'No USB key found. Check whether you have installed the certificate maker.',
        detailArgs: 'No USB key found. Check whether you have installed the certificate maker.',
        adviceArgs: 'Check the network or whether the driver is installed.',
    },
    3489660930: {
        descArgs: 'HTTPS request failed.',
        reasonArgs: 'HTTPS request failed.',
        detailArgs: 'HTTPS request failed.',
        adviceArgs: 'Check whether the parameters are correct.',
    },
    3489660931: {
        descArgs: 'The HTTPS return value is abnormal.',
        reasonArgs: 'The HTTPS return value is abnormal.',
        detailArgs: 'The HTTPS return value is abnormal.',
        adviceArgs: 'Check whether the parameters are correct.',
    },
    3758096385: {
        descArgs: 'Operation failed.',
        reasonArgs: 'Operation failed.',
        detailArgs: 'Operation failed.',
        adviceArgs: '',
    },
    3758096386: {
        descArgs: 'The user cancels the operation.',
        reasonArgs: 'The user cancels the operation.',
        detailArgs: 'The user cancels the operation.',
        adviceArgs: '',
    },
    3758096387: {
        descArgs: 'Invalid parameter.',
        reasonArgs: 'Invalid parameter.',
        detailArgs: 'Invalid parameter.',
        adviceArgs: '',
    },
    3758096388: {
        descArgs: 'The buffer space is insufficient.',
        reasonArgs: 'The buffer space is insufficient.',
        detailArgs: 'The buffer space is insufficient.',
        adviceArgs: '',
    },
    3758096389: {
        descArgs: 'There is not enough memory to execute the requested function.',
        reasonArgs: 'There is not enough memory to execute the requested function.',
        detailArgs: 'There is not enough memory to perform the requested function.',
        adviceArgs: '',
    },
    3758096390: {
        descArgs: 'No initialization.',
        reasonArgs: 'No initialization.',
        detailArgs: 'No initialization.',
        adviceArgs: '',
    },
    3758096391: {
        descArgs: 'The function has been discarded.',
        reasonArgs: 'The function has been discarded.',
        detailArgs: 'The function is deprecated.',
        adviceArgs: '',
    },
    3758096392: {
        descArgs: 'The function is not supported.',
        reasonArgs: 'The function is not supported.',
        detailArgs: 'The function is not supported.',
        adviceArgs: '',
    },
    3758096393: {
        descArgs: 'The function does not support parallel operations.',
        reasonArgs: 'The function does not support parallel operations.',
        detailArgs: 'The function does not support parallel operations.',
        adviceArgs: '',
    },
    3758096394: {
        descArgs: 'The access function is rejected.',
        reasonArgs: 'The access function is rejected.',
        detailArgs: 'Access function denied.',
        adviceArgs: '',
    },
    3758096395: {
        descArgs: 'Invalid handle.',
        reasonArgs: 'Invalid handle.',
        detailArgs: 'Invalid handle.',
        adviceArgs: '',
    },
    3758096396: {
        descArgs: 'Failed to create the object.',
        reasonArgs: 'Failed to create the object.',
        detailArgs: 'Failed to create the object.',
        adviceArgs: '',
    },
    3758096397: {
        descArgs: 'Invalid object.',
        reasonArgs: 'The object is invalid.',
        detailArgs: 'Invalid object.',
        adviceArgs: '',
    },
    3758096398: {
        descArgs: 'Object not found.',
        reasonArgs: 'Object not found.',
        detailArgs: 'Object not found.',
        adviceArgs: '',
    },
    3758096399: {
        descArgs: 'The file does not exist or the password is not verified.',
        reasonArgs: 'The file does not exist or the password is not verified.',
        detailArgs: 'The file does not exist or the password is not verified.',
        adviceArgs: '',
    },
    3758096400: {
        descArgs: 'The file already exists.',
        reasonArgs: 'The file already exists.',
        detailArgs: 'The file already exists.',
        adviceArgs: '',
    },
    3758096401: {
        descArgs: 'Failed to operate the file.',
        reasonArgs: 'Failed to operate the file.',
        detailArgs: 'Failed to operate the file.',
        adviceArgs: '',
    },
    3758096402: {
        descArgs: 'Failed to read the file.',
        reasonArgs: 'Failed to read the file.',
        detailArgs: 'Failed to read the file.',
        adviceArgs: '',
    },
    3758096403: {
        descArgs: 'Failed to write the file.',
        reasonArgs: 'Failed to write the file.',
        detailArgs: 'Failed to write the file.',
        adviceArgs: '',
    },
    3758096404: {
        descArgs: 'Failed to load the DLL library.',
        reasonArgs: 'Failed to load the DLL library.',
        detailArgs: 'Failed to load the DLL library.',
        adviceArgs: '',
    },
    3758096405: {
        descArgs: 'Failed to obtain the function handle.',
        reasonArgs: 'Failed to obtain the function handle.',
        detailArgs: 'Failed to obtain the function handle.',
        adviceArgs: '',
    },
    3758096406: {
        descArgs: 'Service timed out.',
        reasonArgs: 'Service timed out.',
        detailArgs: 'Service timed out.',
        adviceArgs: '',
    },
    3758096407: {
        descArgs:
            'The password operation status provided for saving is invalid and cannot be restored in the specified dialog.',
        reasonArgs: 'The password operation status provided is invalid and cannot be restored in the specified dialog.',
        detailArgs:
            'The password operation state provided for saving is invalid and cannot be restored in the specified dialog.',
        adviceArgs: '',
    },
    3758096408: {
        descArgs:
            'The requested information cannot be obtained because the token considers the requested information sensitive or unwilling to display it.',
        reasonArgs:
            'The requested information cannot be obtained because the token considers the requested information sensitive or unwilling to display it.',
        detailArgs:
            'The requested information cannot be obtained because the token considers the requested information sensitive or unwilling to display it.',
        adviceArgs: '',
    },
    3758096409: {
        descArgs:
            'The password operation state of the specified dialog cannot be saved for some reason (may be that the token cannot save the current state).',
        reasonArgs:
            'The password operation state of the specified dialog cannot be saved for some reason (may be that the token cannot save the current state).',
        detailArgs:
            'The cryptographic operation state of the specified conversation cannot be saved for some reason (may be that the token cannot save the current state).',
        adviceArgs: '',
    },
    3758096410: {
        descArgs:
            'The function cannot be executed because the Cryptoki library has not been initialized by calling C_Initialize.',
        reasonArgs:
            'The function cannot be executed because the Cryptoki library has not been initialized by calling C_Initialize.',
        detailArgs:
            'The function cannot be executed because the Cryptoki library has not been initialized by calling C_Initialize.',
        adviceArgs: '',
    },
    3758096411: {
        descArgs: 'The Cryptoki library has been initialized.',
        reasonArgs: 'The Cryptoki library has been initialized.',
        detailArgs: 'The Cryptoki library has been initialized.',
        adviceArgs: '',
    },
    3758096412: {
        descArgs: 'A bad mutex object.',
        reasonArgs: 'A bad mutex object.',
        detailArgs: 'A bad mutex object.',
        adviceArgs: '',
    },
    3758096413: {
        descArgs: 'The mutex object is not locked.',
        reasonArgs: 'The mutex object is not locked.',
        detailArgs: 'The mutex object is not locked.',
        adviceArgs: '',
    },
    3758096414: {
        descArgs: 'The specified key is not the correct type of key to use with the specified mechanism.',
        reasonArgs: 'The specified key is not the correct type of key to use with the specified mechanism.',
        detailArgs: 'The specified key is not the correct type of key to use with the specified mechanism.',
        adviceArgs: '',
    },
    3758096415: {
        descArgs:
            'An additional key is provided for C_SetOperationState. For example, try to recover a session that is performing a message digest operation and provide an encryption key.',
        reasonArgs:
            'An additional key is provided for C_SetOperationState. For example, try to recover a conversation that is performing a message digest operation and provide an encryption key.',
        detailArgs:
            'An additional key is provided for C_SetOperationState. For example, try to recover a dialog that is performing a message digest operation and provide an encryption key.',
        adviceArgs: '',
    },
    3758096416: {
        descArgs: 'The specified key is not the same key used in the original dialog.',
        reasonArgs: 'The specified key is not the same key used in the original saved dialog.',
        detailArgs: 'The specified key is not the same key used in the previously saved dialog.',
        adviceArgs: '',
    },
    3758096417: {
        descArgs:
            'It indicates that the state of the dialog cannot be restored because C_SetOperationState needs to be supplied with one or more keys used in the original saved dialog.',
        reasonArgs:
            'It indicates that the state of the dialog cannot be restored because one or more keys used in the original saved dialog need to be provided to C_SetOperationState.',
        detailArgs:
            'This indicates that the state of the dialog cannot be restored because C_SetOperationState needs to be supplied with one or more keys used in the original saved dialog.',
        adviceArgs: '',
    },
    3758096418: {
        descArgs: 'The value of the specified key cannot be digested for some reason.',
        reasonArgs: 'The value of the specified key cannot be digested for some reason.',
        detailArgs: 'The value of the specified key cannot be digested for some reason.',
        adviceArgs: '',
    },
    3758096419: {
        descArgs: 'The key is not set to the allowed encryption purpose.',
        reasonArgs:
            'An attempt to use the key to achieve the encryption purpose that the key attribute is not set to allow.',
        detailArgs: 'Attempting to use a key for encryption purposes that the key properties are not set to allow.',
        adviceArgs: '',
    },
    3758096420: {
        descArgs:
            'The Cryptoki (or token) cannot request a packaging key, although the specified private or secret key does not have its own CKA_UNEXTRACTABLE property set to TRUE (It is possible that tokens can only package a given key with a particular type of key, but the specified packaged key is not one of these types). Compare with CKR_KEY_UNEXTRACTABLE.',
        reasonArgs:
            'The Cryptoki (or token) cannot request a packaging key, although the specified private or secret key does not set its own CKA_UNEXTRACTABLE attribute to TRUE (A token may only package a given key with a particular type of key, but the specified packaged key is not one of these types). Compare with CKR_KEY_UNEXTRACTABLE.',
        detailArgs:
            'The Cryptoki (or token) cannot request a packaging key, although the specified private or secret key does not have its own CKA_UNEXTRACTABLE property set to TRUE (A token may only package a given key with a particular type of key, but the specified packaged key is not one of these types). Compare with CKR_KEY_UNEXTRACTABLE.',
        adviceArgs: '',
    },
    3758096421: {
        descArgs:
            'The specified private or secret key cannot be packaged because its CKA_UNEXTRACTABLE property is set to TRUE.',
        reasonArgs:
            'The specified private or secret key cannot be packaged because its CKA_UNEXTRACTABLE property is set to TRUE.',
        detailArgs:
            'The specified private or secret key cannot be packaged because its CKA_UNEXTRACTABLE property is set to TRUE.',
        adviceArgs: '',
    },
    3758096422: {
        descArgs: 'Incorrect key usage.',
        reasonArgs: 'Incorrect key usage.',
        detailArgs: 'Incorrect key usage.',
        adviceArgs: '',
    },
    3758096423: {
        descArgs: 'The specified key handle is invalid.',
        reasonArgs: 'The specified key handle is invalid.',
        detailArgs: 'The specified key handle is invalid.',
        adviceArgs: '',
    },
    3758096424: {
        descArgs: 'The size of the key provided is outside the range of key sizes it can manage.',
        reasonArgs: 'The size of the key provided is beyond the size of the key it can manage.',
        detailArgs: 'The size of the key provided is outside of the key size it can manage.',
        adviceArgs: '',
    },
    3758096425: {
        descArgs: 'Specify an invalid mechanism for password operations.',
        reasonArgs: 'Specifies an invalid mechanism for cryptographic operations.',
        detailArgs: 'Specifies an invalid mechanism for cryptographic operations.',
        adviceArgs: '',
    },
    3758096426: {
        descArgs: 'An invalid parameter was provided for the mechanism specified for cryptographic operation.',
        reasonArgs: 'An invalid parameter was provided for the mechanism specified for cryptographic operations.',
        detailArgs: 'An invalid argument was provided for the mechanism specified for cryptographic operations.',
        adviceArgs: '',
    },
    3758096427: {
        descArgs: 'Incorrect key type.',
        reasonArgs: 'Incorrect key type.',
        detailArgs: 'Incorrect key type.',
        adviceArgs: '',
    },
    3758096428: {
        descArgs: 'The key is not found.',
        reasonArgs: 'The key is not found.',
        detailArgs: 'The key is not found.',
        adviceArgs: '',
    },
    3758096429: {
        descArgs: 'The packaging key provided is invalid.',
        reasonArgs: 'The packaging key provided is invalid.',
        detailArgs: 'The packaging key provided is invalid.',
        adviceArgs: '',
    },
    3758096430: {
        descArgs: 'The packaging key can be regarded as invalid only based on the key length.',
        reasonArgs: 'The packaging key can be considered invalid based on the length of the key.',
        detailArgs: 'The packaging key can be considered invalid based on the length of the key.',
        adviceArgs: '',
    },
    3758096431: {
        descArgs: 'The key handle used to pack another key is invalid.',
        reasonArgs: 'The key handle used to pack another key is invalid.',
        detailArgs: 'The key handle used to package another key is invalid.',
        adviceArgs: '',
    },
    3758096432: {
        descArgs:
            'Indexed that the requested packaging operation could theoretically be performed, but in practice the Cryptoki library (or token) could not be performed because the size of the packaging key provided was outside of the size of the key it could handle.',
        reasonArgs:
            'In theory, the requested packaging operation can be performed, but in practice the Cryptoki library (or token) cannot, because the size of the packaging key provided is beyond the size of the key it can handle.',
        detailArgs:
            'The description theoretically can perform the requested packaging operation, but in practice the Cryptoki library (or token) cannot, because the size of the packaging key provided is outside the range of the key size it can handle.',
        adviceArgs: '',
    },
    3758096433: {
        descArgs: 'The key type for packaging another key is different from the specified packaging mechanism.',
        reasonArgs: 'The key type for packaging another key is inconsistent with the specified packaging mechanism.',
        detailArgs:
            'The key type specified for packaging another key is inconsistent with the specified packaging mechanism.',
        adviceArgs: '',
    },
    3758096434: {
        descArgs: 'The key handle specified for unpacking another key is invalid.',
        reasonArgs: 'The key handle specified for decompressing another key is invalid.',
        detailArgs: 'The key handle specified for decompressing another key is invalid.',
        adviceArgs: '',
    },
    3758096435: {
        descArgs:
            'Denoting that although the requested unpack operation cannot be performed theoretically, the Cryptoki library (or token) cannot actually be performed because the key size is outside the range of key sizes it can handle.',
        reasonArgs:
            'Indexion that although the requested unpacking operation cannot be performed theoretically, the Cryptoki library (or token) cannot actually be performed because the key size is beyond what it can handle.',
        detailArgs:
            'Denoting that although the requested unpacking operation cannot be performed theoretically, the Cryptoki library (or token) cannot actually be performed because the key size is outside of the key size it can handle.',
        adviceArgs: '',
    },
    3758096436: {
        descArgs:
            'The key type specified to unpack another key is different from the mechanism specified to unpack the other key.',
        reasonArgs:
            'The key type specified to unpack another key is inconsistent with the mechanism specified to unpack.',
        detailArgs: 'The key type specified to unpack another key is different from the mechanism specified to unpack.',
        adviceArgs: '',
    },
    3758096437: {
        descArgs:
            'There is already an active action (or combination of active actions) to prevent Cryptoki from activating the specified action.',
        reasonArgs:
            'There is already an active action (or combination of active actions) to prevent Cryptoki from activating the specified action.',
        detailArgs:
            'There is already an active action (or combination of active actions) that prevents Cryptoki from activating the specified action.',
        adviceArgs: '',
    },
    3758096438: {
        descArgs: 'There are no active actions of the appropriate type in the specified dialog.',
        reasonArgs: 'There are no active actions of the appropriate type in the specified dialog.',
        detailArgs: 'There are no active actions of the appropriate type in the specified dialog.',
        adviceArgs: '',
    },
    3758096439: {
        descArgs: 'Incorrect name length.',
        reasonArgs: 'Incorrect name length.',
        detailArgs: 'Incorrect name length.',
        adviceArgs: '',
    },
    3758096440: {
        descArgs: 'The length of the module is incorrect.',
        reasonArgs: 'The length of the module is incorrect.',
        detailArgs: 'Incorrect module length.',
        adviceArgs: '',
    },
    3758096441: {
        descArgs: 'Incorrect parameter.',
        reasonArgs: 'Incorrect parameter.',
        detailArgs: 'Incorrect input parameter.',
        adviceArgs: '',
    },
    3758096442: {
        descArgs: 'The length of the input parameter is incorrect.',
        reasonArgs: 'The length of the input parameter is incorrect.',
        detailArgs: 'The length of the input parameter is incorrect.',
        adviceArgs: '',
    },
    3758096443: {
        descArgs: 'Failed to generate a random number.',
        reasonArgs: 'Failed to generate a random number.',
        detailArgs: 'Failed to generate a random number.',
        adviceArgs: '',
    },
    3758096444: {
        descArgs: "The random number generator of the token does not receive the application's seed.",
        reasonArgs: "The random number generator for the token does not receive the application's seed.",
        detailArgs: "The random number generator for the token does not receive the application's value.",
        adviceArgs: '',
    },
    3758096445: {
        descArgs: 'Indicating that the specified token does not have a random number generator.',
        reasonArgs: 'Indicating that the specified token does not have a random number generator.',
        detailArgs: 'Indicate that the specified token does not have a random number generator.',
        adviceArgs: '',
    },
    3758096446: {
        descArgs:
            'Indicated that some terrible and irreparable error has occurred. In the worst case, the function may partially succeed and the computer and/or token are in an incompatible state.',
        reasonArgs:
            'Indicated that some terrible and irretrievable error has occurred. In the worst case, the function may partially succeed and the computer and/or token are in an incompatible state.',
        detailArgs:
            'Indicate that some terrible and irretrievable error has occurred. In the worst case, the function may partially succeed and the computer and/or token are in an incompatible state.',
        adviceArgs: '',
    },
    3758096447: {
        descArgs: 'The specified slot ID is invalid.',
        reasonArgs: 'The specified slot ID is invalid.',
        detailArgs: 'The specified slot ID is invalid.',
        adviceArgs: '',
    },
    3758096448: {
        descArgs: 'Some problem has occurred because of tokens and/or slots.',
        reasonArgs: 'Some problem has occurred because of tokens and/or slots.',
        detailArgs: 'There is a problem with tokens and/or slots.',
        adviceArgs: '',
    },
    3758096449: {
        descArgs: 'The token does not have enough memory to perform the requested function.',
        reasonArgs: 'The token does not have enough memory to execute the requested function.',
        detailArgs: 'The token does not have enough memory to perform the requested function.',
        adviceArgs: '',
    },
    3758096450: {
        descArgs: 'The token was removed from the slot during function execution.',
        reasonArgs: 'The token was removed from the slot during function execution.',
        detailArgs: 'The token was removed from the slot during function execution.',
        adviceArgs: '',
    },
    3758096451: {
        descArgs: 'The token is not in the slot when the function is invoked.',
        reasonArgs: 'The token is not in the slot when this function is invoked.',
        detailArgs: 'The token is not in the slot when this function is called.',
        adviceArgs: '',
    },
    3758096452: {
        descArgs: 'Cryptoki library and/or slot cannot recognize tokens in slot.',
        reasonArgs: 'Cryptoki libraries and/or slots do not recognize tokens in slots.',
        detailArgs: 'Cryptoki library and/or slot cannot recognize tokens in slot.',
        adviceArgs: '',
    },
    3758096453: {
        descArgs: 'The requested action cannot be performed because the token is write-protected.',
        reasonArgs: 'The requested action cannot be performed because the token is write-protected.',
        detailArgs: 'The requested action cannot be performed because the token is write-protected.',
        adviceArgs: '',
    },
    3758096454: {
        descArgs: 'The room space is insufficient.',
        reasonArgs: 'The room space is insufficient.',
        detailArgs: 'The room space is insufficient.',
        adviceArgs: '',
    },
    3758096455: {
        descArgs: 'The number of containers reaches the maximum.',
        reasonArgs: 'The number of containers reaches the maximum.',
        detailArgs: 'Maximum number of containers reached.',
        adviceArgs: '',
    },
    3758096456: {
        descArgs:
            'This value is returned when C_GetSlotEvent is called in non-blocking mode and no new slot event is returned.',
        reasonArgs:
            'This value is returned when C_GetSlotEvent is called in non-blocking mode and no new slot event is returned.',
        detailArgs:
            'This value is returned when C_GetSlotEvent is called in non-blocking mode and no new slot event is returned.',
        adviceArgs: '',
    },
    3758096457: {
        descArgs: 'The library cannot perform its functions properly if it cannot generate new threads.',
        reasonArgs: 'The library cannot perform its functions properly if it cannot generate new threads.',
        detailArgs: 'The library cannot perform its functions properly if it cannot generate new threads.',
        adviceArgs: '',
    },
    3758096458: {
        descArgs:
            'This means that this type of lock requested by the application due to thread safety cannot be used in the library, so the application cannot use the library in the specified manner.',
        reasonArgs:
            'This means that this type of lock requested by the application due to thread safety is not available in the library, so the application cannot use the library in the specified manner.',
        detailArgs:
            'This means that this type of lock requested by the application because of thread safety is not available in the library, so the application cannot use the library in the specified manner.',
        adviceArgs: '',
    },
    3758096459: {
        descArgs: 'Close the dialog during function execution.',
        reasonArgs: 'The dialog is closed during function execution.',
        detailArgs: 'Close the dialog while the function is being executed.',
        adviceArgs: '',
    },
    3758096460: {
        descArgs:
            'The attempt to open a dialog failed either because the token has too many conversations open or because the token has too many read/write conversations open.',
        reasonArgs:
            'The attempt to open a dialog failed either because too many conversations were open to the token or because too many read/write conversations were open to the token.',
        detailArgs:
            'The attempt to open a dialog failed either because the token has too many dialogs open or because the token has too many read/write dialogs open.',
        adviceArgs: '',
    },
    3758096461: {
        descArgs: 'When the function is invoked, the specified dialog handle is invalid.',
        reasonArgs: 'When the function is invoked, the specified dialog handle is invalid.',
        detailArgs: 'The specified dialog handle is invalid when the function is called.',
        adviceArgs: '',
    },
    3758096462: {
        descArgs: 'The specified dialog cannot get the desired action because it is a read-only dialog.',
        reasonArgs: 'The specified dialog cannot get the desired action because it is a read-only dialog.',
        detailArgs: 'The specified dialog cannot get the desired action because it is a read-only dialog.',
        adviceArgs: '',
    },
    3758096463: {
        descArgs: 'The token cannot be initialized because the dialog with the token has been opened.',
        reasonArgs: 'The token cannot be initialized because the dialog with the token has been opened.',
        detailArgs: 'The token cannot be initialized because the dialog with the token has been opened.',
        adviceArgs: '',
    },
    3758096464: {
        descArgs: 'The read-only dialog already exists, so the SO cannot be registered.',
        reasonArgs: 'The read-only dialog already exists. Therefore, the SO cannot be registered.',
        detailArgs: 'The read-only dialog already exists. Therefore, the SO cannot be registered.',
        adviceArgs: '',
    },
    3758096465: {
        descArgs: 'The read/write SO dialog already exists. Therefore, the read-only dialog cannot be opened.',
        reasonArgs: 'The read/write SO dialog already exists. Therefore, the read-only dialog cannot be opened.',
        detailArgs: 'The read/write SO dialog already exists. Therefore, the read-only dialog cannot be opened.',
        adviceArgs: '',
    },
    3758096466: {
        descArgs: 'The specified token does not support parallel dialog.',
        reasonArgs: 'The specified token does not support parallel conversations.',
        detailArgs: 'The specified token does not support parallel conversations.',
        adviceArgs: '',
    },
    3758096467: {
        descArgs: 'The application name is invalid.',
        reasonArgs: 'The application name is invalid.',
        detailArgs: 'The application name is invalid.',
        adviceArgs: '',
    },
    3758096468: {
        descArgs: 'The application already exists.',
        reasonArgs: 'The application already exists.',
        detailArgs: 'The application already exists.',
        adviceArgs: '',
    },
    3758096469: {
        descArgs: 'The application does not exist.',
        reasonArgs: 'The application does not exist.',
        detailArgs: 'The application does not exist.',
        adviceArgs: '',
    },
    3758096470: {
        descArgs: 'The specified PIN is incorrect.',
        reasonArgs: 'The specified PIN is incorrect.',
        detailArgs: 'The specified PIN is incorrect.',
        adviceArgs: '',
    },
    3758096471: {
        descArgs: 'The specified PIN is locked and cannot be used.',
        reasonArgs: 'The specified PIN is locked and cannot be used.',
        detailArgs: "The specified PIN is'locked' and cannot be used.",
        adviceArgs: '',
    },
    3758096472: {
        descArgs: 'The specified PIN contains invalid characters.',
        reasonArgs: 'The specified PIN contains invalid characters.',
        detailArgs: 'The specified PIN contains invalid characters.',
        adviceArgs: '',
    },
    3758096473: {
        descArgs: 'The specified PIN is too long or too short.',
        reasonArgs: 'The specified PIN is too long or too short.',
        detailArgs: 'The specified PIN is too long or too short.',
        adviceArgs: '',
    },
    3758096474: {
        descArgs:
            'The desired action cannot be performed because the appropriate user (or an appropriate user) is not registered.',
        reasonArgs:
            'The desired action cannot be performed because the appropriate user (or an appropriate user) is not registered.',
        detailArgs:
            'The desired action cannot be performed because the appropriate user (or an appropriate user) is not registered.',
        adviceArgs: '',
    },
    3758096475: {
        descArgs:
            'The specified user cannot register to the conversation because it has already registered to the conversation.',
        reasonArgs:
            'The specified user cannot register to the conversation because it has already registered to the conversation.',
        detailArgs:
            'The specified user cannot register into the conversation because it is already registered into the conversation.',
        adviceArgs: '',
    },
    3758096476: {
        descArgs:
            'Other users have registered the conversation, so the specified user cannot register the conversation.',
        reasonArgs:
            'Other users have registered the conversation, so the specified user cannot register the conversation.',
        detailArgs:
            'The specified user cannot be registered with the dialog because other users have already registered with the dialog.',
        adviceArgs: '',
    },
    3758096477: {
        descArgs: 'C_InitPIN cannot be used to initialize the PIN of a common subscriber.',
        reasonArgs: 'C_InitPIN cannot be used to initialize the PIN of a common subscriber.',
        detailArgs: 'The C_InitPIN cannot be used to initialize the PIN of a common user.',
        adviceArgs: '',
    },
    3758096478: {
        descArgs:
            'The specified PIN has expired. The requested operation cannot be performed unless C_SetPIN is called to change the PIN value. Whether or not the PIN of a normal user on a token expires varies depending on the token.',
        reasonArgs:
            'The specified PIN has expired. The requested operation cannot be performed unless C_SetPIN is called to change the PIN value. Whether or not the PIN of a normal user on a token expires varies depending on the token.',
        detailArgs:
            'The specified PIN has expired. The requested operation cannot be performed unless C_SetPIN is called to change the PIN value. Whether or not the PIN of a normal user on a token expires varies depending on the token.',
        adviceArgs: '',
    },
    3758096479: {
        descArgs: 'Specify an invalid value as CK_USER_TYPE.',
        reasonArgs: 'Specifies an invalid value as CK_USER_TYPE.',
        detailArgs: 'Specifies an invalid value as CK_USER_TYPE.',
        adviceArgs: '',
    },
    3758096480: {
        descArgs:
            'Try to register more different users in the token at the same time than the token and/or library allows.',
        reasonArgs:
            'Try to register more different users in the token at the same time than the token and/or library allows.',
        detailArgs:
            'Try to register more different users in the token simultaneously than the token and/or library allows.',
        adviceArgs: '',
    },
    3758096481: {
        descArgs: 'The certificate is not found.',
        reasonArgs: 'The certificate is not found.',
        detailArgs: 'The certificate is not found.',
        adviceArgs: '',
    },
    3758096482: {
        descArgs: 'The object is not exported.',
        reasonArgs: 'The object is not exported.',
        detailArgs: 'The object is not exported.',
        adviceArgs: '',
    },
    3758096483: {
        descArgs: 'The MAC address length is incorrect.',
        reasonArgs: 'The MAC length is incorrect.',
        detailArgs: 'Incorrect MAC length.',
        adviceArgs: '',
    },
    3758096484: {
        descArgs: 'The DOMAIN parameter is incorrect.',
        reasonArgs: 'The DOMAIN parameter is incorrect.',
        detailArgs: 'The DOMAIN parameter is incorrect.',
        adviceArgs: '',
    },
    3758096485: {
        descArgs: 'The abstract object is incorrect.',
        reasonArgs: 'The abstract object is incorrect.',
        detailArgs: 'The summary object is incorrect.',
        adviceArgs: '',
    },
    3758096486: {
        descArgs: 'HASH calculation error.',
        reasonArgs: 'HASH calculation error.',
        detailArgs: 'HASH calculation error.',
        adviceArgs: '',
    },
    3758096487: {
        descArgs: 'HASH values are not equal.',
        reasonArgs: 'The hash values are not equal.',
        detailArgs: 'HASH values are not equal.',
        adviceArgs: '',
    },
    3758096488: {
        descArgs: 'Failed to generate the RSA key.',
        reasonArgs: 'Failed to generate the RSA key.',
        detailArgs: 'Failed to generate the RSA key.',
        adviceArgs: '',
    },
    3758096489: {
        descArgs: 'The RSA key template length is incorrect.',
        reasonArgs: 'The RSA key length is incorrect.',
        detailArgs: 'RSA key module length error.',
        adviceArgs: '',
    },
    3758096490: {
        descArgs: 'An error occurred when the public key was imported to the CSP.',
        reasonArgs: 'An error occurs when the public key is imported to the CSP service.',
        detailArgs: 'An error occurred when the public key was imported to the CSP.',
        adviceArgs: '',
    },
    3758096491: {
        descArgs: 'RSA encryption failed.',
        reasonArgs: 'RSA encryption failed.',
        detailArgs: 'RSA encryption failed.',
        adviceArgs: '',
    },
    3758096492: {
        descArgs: 'RSA decryption failed.',
        reasonArgs: 'RSA decryption failed.',
        detailArgs: 'RSA decryption failed.',
        adviceArgs: '',
    },
    3758096493: {
        descArgs: 'Encrypted data is invalid.',
        reasonArgs: 'Encrypted data is invalid.',
        detailArgs: 'Encrypted data is invalid.',
        adviceArgs: '',
    },
    3758096494: {
        descArgs: 'The length of the encrypted data is invalid.',
        reasonArgs: 'The length of the encrypted data is invalid.',
        detailArgs: 'The length of the encrypted data is invalid.',
        adviceArgs: '',
    },
    3758096495: {
        descArgs: 'A patch error occurred during decryption.',
        reasonArgs: 'A patch error occurred during decryption.',
        detailArgs: 'A patch error occurred during decryption.',
        adviceArgs: '',
    },
    3758096496: {
        descArgs: 'The provided signature/MAC is invalid.',
        reasonArgs: 'Invalid signature/MAC provided.',
        detailArgs: 'Invalid signature/MAC provided.',
        adviceArgs: '',
    },
    3758096497: {
        descArgs: 'Invalid signature length.',
        reasonArgs: 'Invalid signature length.',
        detailArgs: 'Invalid signature length.',
        adviceArgs: '',
    },
    3758096498: {
        descArgs: 'The template specified to create an object is incomplete and is missing some necessary properties.',
        reasonArgs:
            'The template specified to create an object is incomplete and is missing some necessary properties.',
        detailArgs:
            'The template specified to create an object is incomplete and is missing some necessary properties.',
        adviceArgs: '',
    },
    3758096499: {
        descArgs: 'The template specified to create an object has contradictory properties.',
        reasonArgs: 'The template specified to create an object has contradictory properties.',
        detailArgs: 'The template specified to create an object has contradictory properties.',
        adviceArgs: '',
    },
    3758096500: {
        descArgs: 'An attempt was made to set a value for an attribute that may not have been set or modified.',
        reasonArgs: 'An attempt was made to set a value for an attribute that may not have been set or modified.',
        detailArgs: 'An attempt was made to set a value for an attribute that may not have been set or modified.',
        adviceArgs: '',
    },
    3758096501: {
        descArgs:
            'An attempt was made to obtain an attribute value for an object that was not satisfactory because of its sensitivity or non-extractability.',
        reasonArgs:
            'An attempt is made to obtain the value of an attribute of an object that is not satisfied because of its sensitivity or non-extractability.',
        detailArgs:
            'An attempt was made to obtain an attribute value for an object that is not satisfactory because of its sensitivity or non-extractability.',
        adviceArgs: '',
    },
    3758096502: {
        descArgs: 'An invalid attribute specified in the template.',
        reasonArgs: 'An invalid attribute specified in the template.',
        detailArgs: 'An invalid attribute specified in the template.',
        adviceArgs: '',
    },
    3758096503: {
        descArgs: 'Specify an invalid value for an attribute in the template.',
        reasonArgs: 'Specify an invalid value for an attribute in the template.',
        detailArgs: 'Specify an invalid value for an attribute in the template.',
        adviceArgs: '',
    },
    3758096504: {
        descArgs: 'No certificate is selected.',
        reasonArgs: 'No certificate is selected.',
        detailArgs: 'No certificate is selected.',
        adviceArgs: '',
    },
    3758096505: {
        descArgs: 'The certificate is invalid (the certificate has expired or has not taken effect).',
        reasonArgs: 'The certificate is invalid (the certificate has expired or has not taken effect).',
        detailArgs: 'The certificate is invalid (the certificate has expired or has not taken effect).',
        adviceArgs: '',
    },
    3758096506: {
        descArgs: 'PFX failed to verify the password.',
        reasonArgs: 'PFX failed to verify the password.',
        detailArgs: 'PFX failed to verify the password.',
        adviceArgs: '',
    },
    3758096507: {
        descArgs: 'The certificate is a public key certificate.',
        reasonArgs: 'The certificate is a public key certificate.',
        detailArgs: 'The certificate is a public key certificate.',
        adviceArgs: '',
    },
    3758096508: {
        descArgs: 'The object already exists.',
        reasonArgs: 'The object already exists.',
        detailArgs: 'The object already exists.',
        adviceArgs: '',
    },
    3758096509: {
        descArgs: 'No matching node exists in XML.',
        reasonArgs: 'No matching node exists in XML.',
        detailArgs: 'No matching node exists in the XML.',
        adviceArgs: '',
    },
    3758096510: {
        descArgs: 'Base64 encoding failed.',
        reasonArgs: 'Base64 encoding failed.',
        detailArgs: 'Base64 encoding failed.',
        adviceArgs: '',
    },
    3758096512: {
        descArgs: 'Failed to decode Base64.',
        reasonArgs: 'Base64 decoding failed.',
        detailArgs: 'Base64 decoding failed.',
        adviceArgs: '',
    },
    3758096513: {
        descArgs: 'An error occurred when obtaining the version.',
        reasonArgs: 'An error occurred when obtaining the version.',
        detailArgs: 'An error occurred when obtaining the version.',
        adviceArgs: '',
    },
    3758096514: {
        descArgs: 'No valid recipient information is found.',
        reasonArgs: 'No valid recipient information is found.',
        detailArgs: 'No valid recipient information is found.',
        adviceArgs: '',
    },
    3758096515: {
        descArgs: 'The data length is insufficient.',
        reasonArgs: 'The data length is insufficient.',
        detailArgs: 'Insufficient data length.',
        adviceArgs: '',
    },
    3758096516: {
        descArgs: 'The obtained data is not ready.',
        reasonArgs: 'The obtained data is not ready.',
        detailArgs: 'The obtained data is not ready.',
        adviceArgs: '',
    },
    3758096517: {
        descArgs: 'No available state secret device is found.',
        reasonArgs: 'No available state secret devices are found.',
        detailArgs: 'No available secret devices are found.',
        adviceArgs: '',
    },
    3758096518: {
        descArgs: 'No available CSP device is found.',
        reasonArgs: 'No available CSP device is found.',
        detailArgs: 'No available CSP devices are found.',
        adviceArgs: '',
    },
    3758096519: {
        descArgs: 'Failed to obtain the file size.',
        reasonArgs: 'Failed to obtain the file size.',
        detailArgs: 'Failed to obtain the file size.',
        adviceArgs: '',
    },
    3758096520: {
        descArgs: 'The file content is empty.',
        reasonArgs: 'The file content is empty.',
        detailArgs: 'The file content is empty.',
        adviceArgs: '',
    },
    3758096521: {
        descArgs: 'The file content is incorrect.',
        reasonArgs: 'The file content is incorrect.',
        detailArgs: 'The file content is incorrect.',
        adviceArgs: '',
    },
    3758096522: {
        descArgs: 'The hybrid certificate is not supported.',
        reasonArgs: 'Hybrid certificates are not supported.',
        detailArgs: 'Mixed certificates are not supported.',
        adviceArgs: '',
    },
    3758096523: {
        descArgs: 'Mixed signatures are not supported.',
        reasonArgs: 'Mixed signatures are not supported.',
        detailArgs: 'Mixed signatures are not supported.',
        adviceArgs: '',
    },
    3758096524: {
        descArgs: 'different signature types.',
        reasonArgs: 'different signature types.',
        detailArgs: 'different signature types.',
        adviceArgs: '',
    },
    3758096525: {
        descArgs: 'The original signature is inconsistent.',
        reasonArgs: 'The signature result is inconsistent with the original text.',
        detailArgs: 'The original signature result is inconsistent.',
        adviceArgs: '',
    },
    3758096526: {
        descArgs: 'Failed to parse the XML file.',
        reasonArgs: 'Failed to parse the XML file.',
        detailArgs: 'Failed to parse the XML file.',
        adviceArgs: '',
    },
    3758096527: {
        descArgs: 'Invalid data.',
        reasonArgs: 'Invalid data.',
        detailArgs: 'Invalid data.',
        adviceArgs: '',
    },
    3758096528: {
        descArgs: 'The specified attribute is not found.',
        reasonArgs: 'The specified attribute is not found.',
        detailArgs: 'The specified attribute is not found.',
        adviceArgs: '',
    },
    3758096529: {
        descArgs: 'There is not enough storage.',
        reasonArgs: 'There is not enough memory.',
        detailArgs: 'There is not enough storage.',
        adviceArgs: '',
    },
    3758096530: {
        descArgs: 'The requested function cannot be performed. The function is not supported.',
        reasonArgs: 'The requested function cannot be performed. The function is not supported.',
        detailArgs: 'The requested function cannot be performed, the function is not supported.',
        adviceArgs: '',
    },
    3758096531: {
        descArgs: 'The parameter is incorrect.',
        reasonArgs: 'The parameter is incorrect.',
        detailArgs: 'Parameter error.',
        adviceArgs: '',
    },
    3758096532: {
        descArgs: 'Incorrect length of the input data.',
        reasonArgs: 'The length of the input data is incorrect.',
        detailArgs: 'The length of the input data is incorrect.',
        adviceArgs: '',
    },
    3758096533: {
        descArgs: 'This function is canceled during execution.',
        reasonArgs: 'This function is canceled during execution.',
        detailArgs: 'This function was canceled during execution.',
        adviceArgs: '',
    },
    3758096534: {
        descArgs: 'Invalid mechanism.',
        reasonArgs: 'Invalid mechanism.',
        detailArgs: 'Invalid mechanism.',
        adviceArgs: '',
    },
    3758096535: {
        descArgs: 'The mechanism parameter is invalid.',
        reasonArgs: 'The mechanism parameter is invalid.',
        detailArgs: 'Invalid parameter for mechanism.',
        adviceArgs: '',
    },
    3758096538: {
        descArgs: 'The key is not found.',
        reasonArgs: 'No key is found.',
        detailArgs: 'Key not found.',
        adviceArgs: '',
    },
    3758096539: {
        descArgs: 'KEY is not initialized.',
        reasonArgs: 'KEY is not initialized.',
        detailArgs: 'KEY is not initialized.',
        adviceArgs: '',
    },
    3758096540: {
        descArgs: 'The number of inserted USB keys exceeds 4.',
        reasonArgs: 'The number of inserted Huada USB Keys exceeds four.',
        detailArgs: 'Too many USB keys are inserted. More than four USB keys are inserted.',
        adviceArgs: '',
    },
    3758096541: {
        descArgs: 'The file content is invalid.',
        reasonArgs: 'The file content is invalid.',
        detailArgs: 'The read file content is invalid.',
        adviceArgs: '',
    },
    3758096542: {
        descArgs: 'Failed to invoke the fopen function.',
        reasonArgs: 'Failed to invoke the fopen function.',
        detailArgs: 'Failed to invoke the fopen function.',
        adviceArgs: '',
    },
    3758096543: {
        descArgs: 'Failed to initialize the context.',
        reasonArgs: 'Failed to initialize the context.',
        detailArgs: 'Failed to initialize the context.',
        adviceArgs: '',
    },
    3758096544: {
        descArgs: 'Failed to clear the context.',
        reasonArgs: 'Failed to clear the context.',
        detailArgs: 'Failed to clear the context.',
        adviceArgs: '',
    },
    3758096545: {
        descArgs: 'Failed to reinstall the password.',
        reasonArgs: 'Failed to reinstall the password.',
        detailArgs: 'Failed to reinstall the password.',
        adviceArgs: '',
    },
    3758096546: {
        descArgs: 'The function is not supported.',
        reasonArgs: 'The function is not supported.',
        detailArgs: 'The function is not supported.',
        adviceArgs: '',
    },
    3758096547: {
        descArgs: 'Filling failed.',
        reasonArgs: 'Filling failed.',
        detailArgs: 'Filling failed.',
        adviceArgs: '',
    },
    3758096548: {
        descArgs: 'Failed to defill.',
        reasonArgs: 'Failed to unfill.',
        detailArgs: 'Defilling failed.',
        adviceArgs: '',
    },
    3758096549: {
        descArgs: 'The system memory is insufficient.',
        reasonArgs: 'The system memory is insufficient.',
        detailArgs: 'The system memory is insufficient.',
        adviceArgs: '',
    },
    3758096550: {
        descArgs: 'Incorrect parameter.',
        reasonArgs: 'Incorrect parameter.',
        detailArgs: 'Incorrect parameter.',
        adviceArgs: '',
    },
    3758096551: {
        descArgs: 'The DER encoding is incorrect.',
        reasonArgs: 'The DER encoding is incorrect.',
        detailArgs: 'DER encoding error.',
        adviceArgs: '',
    },
    3758096552: {
        descArgs: 'DER reverse encoding error.',
        reasonArgs: 'DER reverse encoding error.',
        detailArgs: 'DER reverse encoding error.',
        adviceArgs: '',
    },
    3758096553: {
        descArgs: 'The RSA public key is invalid. The public key structure or DER may be incorrect.',
        reasonArgs: 'The RSA public key is invalid. The public key structure or DER may be incorrect.',
        detailArgs: 'The RSA public key is invalid. The public key structure or DER may be incorrect.',
        adviceArgs: '',
    },
    3758096554: {
        descArgs: 'The RSA private key is invalid. The private key structure or DER may be incorrect.',
        reasonArgs: 'The RSA private key is invalid. The private key structure or DER may be incorrect.',
        detailArgs: 'The RSA private key is invalid. The private key structure or DER may be incorrect.',
        adviceArgs: '',
    },
    3758096555: {
        descArgs: 'The subpacking identifier is incorrect.\t.',
        reasonArgs: 'The subpacking identifier is incorrect.\t.',
        detailArgs: 'The subpacking identifier is incorrect.\t.',
        adviceArgs: '',
    },
    3758161921: {
        descArgs: '(pipe) Invalid object ID.',
        reasonArgs: '(Pipe) Invalid object ID.',
        detailArgs: '(pipe) Invalid object ID.',
        adviceArgs: '',
    },
    3758161922: {
        descArgs: 'Failed to read the header data (pipe).',
        reasonArgs: 'Failed to read header data.',
        detailArgs: 'Failed to read the header data (pipe).',
        adviceArgs: '',
    },
    3758161923: {
        descArgs: 'The size of the extended data of the (pipe) message is incorrect.',
        reasonArgs: 'The size of the extended data of the (pipe) message is incorrect.',
        detailArgs: '(pipeline) message extension data size is incorrect.',
        adviceArgs: '',
    },
    3758161924: {
        descArgs: 'The (pipe) connection is incorrect.',
        reasonArgs: '(pipe) connection error.',
        detailArgs: '(pipe) connection error.',
        adviceArgs: '',
    },
    3758161925: {
        descArgs: '(pipe) waiting for asynchronous response data timed out.',
        reasonArgs: '(pipe) waiting for asynchronous response data timed out.',
        detailArgs: '(pipe) waiting for asynchronous response data timed out.',
        adviceArgs: '',
    },
    3758161926: {
        descArgs: '(pipe) Sending response mechanism, creating temporary service waiting timed out.',
        reasonArgs:
            'The waiting time for the (pipe) sending response mechanism to create a temporary service times out.',
        detailArgs: '(pipe) Sending response mechanism, creating temporary service waiting timed out.',
        adviceArgs: '',
    },
    3758161927: {
        descArgs: 'Failed to wait for the (pipe) event.',
        reasonArgs: 'Failed to wait for the (pipe) event.',
        detailArgs: '(pipe) waiting for the event failed.',
        adviceArgs: '',
    },
    3758161928: {
        descArgs: 'The waiting for the service ready timed out during the (pipe) service startup.',
        reasonArgs: 'The waiting for the service to be ready timed out during the (pipe) service startup.',
        detailArgs: '(pipeline) service startup process timed out waiting for service ready process.',
        adviceArgs: '',
    },
    3758227457: {
        descArgs: 'The USB key has been removed.',
        reasonArgs: 'The USB key has been removed.',
        detailArgs: 'The USB key has been removed.',
        adviceArgs: '',
    },
    3758227458: {
        descArgs: 'USB key signing failed.',
        reasonArgs: 'USB key signing failed.',
        detailArgs: 'USB key signing failed.',
        adviceArgs: '',
    },
    3758227459: {
        descArgs: 'Failed to verify the USB key signature.',
        reasonArgs: 'USB key signature verification failed.',
        detailArgs: 'USB key failed to verify the signature.',
        adviceArgs: '',
    },
    3758227460: {
        descArgs: 'Whether the USB key device is inserted or whether the driver is installed.',
        reasonArgs: 'Whether the USB key device is inserted or whether the driver is installed.',
        detailArgs: 'Whether the USB key device is inserted or whether the driver is installed.',
        adviceArgs: '',
    },
    3758227461: {
        descArgs: 'The USB key device type is not supported.',
        reasonArgs: 'The USB key device type is not supported.',
        detailArgs: 'The USBKEY device type is not supported.',
        adviceArgs: '',
    },
    3758227462: {
        descArgs: 'Failed to load the JITSSL library.',
        reasonArgs: 'Failed to load the JITSSL library.',
        detailArgs: 'Failed to load the JITSSL library.',
        adviceArgs: '',
    },
    3758227463: {
        descArgs: 'Failed to load the USBKEY library function.',
        reasonArgs: 'Failed to load the USBKEY library function.',
        detailArgs: 'Failed to load the USBKEY library function.',
        adviceArgs: '',
    },
    3758227464: {
        descArgs: 'Failed to set the client certificate.',
        reasonArgs: 'Failed to set the client certificate.',
        detailArgs: 'Failed to set the client certificate.',
        adviceArgs: '',
    },
    3758227465: {
        descArgs: 'The CertType configuration item in the Config.ini file is incorrect or missing.',
        reasonArgs: 'The CertType configuration item in the Config.ini file is incorrect or missing.',
        detailArgs: 'The CertType configuration item in the Config.ini file is incorrect or missing.',
        adviceArgs: '',
    },
    3758227466: {
        descArgs: 'The UsePTGetPin configuration item in the Config.ini file is incorrect or missing.',
        reasonArgs: 'The UsePTGetPin configuration item in the Config.ini file is incorrect or missing.',
        detailArgs: 'The UsePTGetPin configuration item in the Config.ini file is incorrect or missing.',
        adviceArgs: '',
    },
    3758227467: {
        descArgs: 'Failed to obtain the server certificate.',
        reasonArgs: 'Failed to obtain the server certificate.',
        detailArgs: 'Failed to obtain the server certificate.',
        adviceArgs: '',
    },
    3758227468: {
        descArgs: 'The certificate has expired.',
        reasonArgs: 'The certificate has expired.',
        detailArgs: 'The certificate has expired.',
        adviceArgs: '',
    },
    3758227469: {
        descArgs: 'The certificate has been deregistered.',
        reasonArgs: 'The certificate has been deregistered.',
        detailArgs: 'The certificate has been deregistered.',
        adviceArgs: '',
    },
    3758227470: {
        descArgs: 'The certificate cannot be identified.',
        reasonArgs: 'The certificate cannot be identified.',
        detailArgs: 'The certificate cannot be recognized.',
        adviceArgs: '',
    },
    3758227471: {
        descArgs: 'The certificate is not issued by this organization.',
        reasonArgs: 'The certificate is not issued by the organization.',
        detailArgs: 'The certificate is not issued by this organization.',
        adviceArgs: '',
    },
    3758227472: {
        descArgs: 'Authentication failed. Check the certificate validity.',
        reasonArgs: 'Authentication failed. Please check the certificate validity.',
        detailArgs: 'Authentication failed. Please check the certificate validity.',
        adviceArgs: '',
    },
    3758227473: {
        descArgs: 'Failed to obtain the server certificate.',
        reasonArgs: 'Failed to obtain the server certificate.',
        detailArgs: 'Failed to obtain the server certificate.',
        adviceArgs: '',
    },
    3758227474: {
        descArgs: 'The certificate has expired.',
        reasonArgs: 'The certificate has expired.',
        detailArgs: 'The certificate has expired.',
        adviceArgs: '',
    },
    3758227475: {
        descArgs: 'The certificate has been deregistered.',
        reasonArgs: 'The certificate has been deregistered.',
        detailArgs: 'Certificate has been deregistered.',
        adviceArgs: '',
    },
    3758227476: {
        descArgs: 'The certificate cannot be identified.',
        reasonArgs: 'The certificate cannot be identified.',
        detailArgs: 'The certificate cannot be recognized.',
        adviceArgs: '',
    },
    3758227477: {
        descArgs: 'The certificate is not issued by the organization.',
        reasonArgs: 'The certificate is not issued by the organization.',
        detailArgs: 'The certificate is not issued by this organization.',
        adviceArgs: '',
    },
    3758227478: {
        descArgs: 'Authentication failed. Please check the certificate validity.',
        reasonArgs: 'Authentication failed. Please check the certificate validity.',
        detailArgs: 'Authentication failed. Please check the certificate validity.',
        adviceArgs: '',
    },
    3758227479: {
        descArgs: 'Failed to initialize the encrypted communication context.',
        reasonArgs: 'Failed to initialize the encrypted communication context.',
        detailArgs: 'Failed to initialize the encrypted communication context.',
        adviceArgs: '',
    },
    3758227480: {
        descArgs: 'Encrypted communication connection failed.',
        reasonArgs: 'Failed to connect the encrypted communication.',
        detailArgs: 'Failed to connect the encrypted communication.',
        adviceArgs: '',
    },
    3758227481: {
        descArgs: 'Encrypted communication is not initialized.',
        reasonArgs: 'Encrypted communication is not initialized.',
        detailArgs: 'Encrypted communication is not initialized.',
        adviceArgs: '',
    },
    3758292993: {
        descArgs: 'The communication connection parameter is invalid.',
        reasonArgs: 'The communication connection parameter is invalid.',
        detailArgs: 'The communication connection parameter is invalid.',
        adviceArgs: '',
    },
    3758292994: {
        descArgs: 'Repeated initialization of communication connection.',
        reasonArgs: 'Repeated initialization of the communication connection.',
        detailArgs: 'Repeated initialization of the communication connection.',
        adviceArgs: '',
    },
    3758292995: {
        descArgs: 'The communication connection is not initialized.',
        reasonArgs: 'The communication connection is not initialized.',
        detailArgs: 'The communication connection is not initialized.',
        adviceArgs: '',
    },
    3758292996: {
        descArgs: 'Communication connection failed.',
        reasonArgs: 'Communication connection failed.',
        detailArgs: 'Communication connection failed.',
        adviceArgs: '',
    },
    3758358529: {
        descArgs: 'Failed to authenticate the third-party identity.',
        reasonArgs: 'Third-party identity authentication failed.',
        detailArgs: 'Third-party identity authentication failed.',
        adviceArgs: '',
    },
    4026531841: {
        descArgs: 'Failed to load the key driver.',
        reasonArgs: 'Failed to load the key driver.',
        detailArgs: 'Failed to load the key driver.',
        adviceArgs: '',
    },
    4026531842: {
        descArgs: 'Failed to initialize the device set.',
        reasonArgs: 'Failed to initialize the device set.',
        detailArgs: 'Failed to initialize the device set.',
        adviceArgs: '',
    },
    4026531843: {
        descArgs: 'Failed to initialize the device management object.',
        reasonArgs: 'Failed to initialize the device management object.',
        detailArgs: 'Failed to initialize the device management object.',
        adviceArgs: '',
    },
    4026531844: {
        descArgs: 'Failed to connect to the device.',
        reasonArgs: 'Failed to connect to the device.',
        detailArgs: 'Failed to connect to the device.',
        adviceArgs: '',
    },
    4026531845: {
        descArgs: 'Failed to create the device.',
        reasonArgs: 'Failed to create the device.',
        detailArgs: 'Failed to create the device.',
        adviceArgs: '',
    },
    4026531846: {
        descArgs: 'Failed to initialize the application object.',
        reasonArgs: 'Failed to initialize the application object.',
        detailArgs: 'Failed to initialize the application object.',
        adviceArgs: '',
    },
    4026531847: {
        descArgs: 'Failed to initialize the hash object.',
        reasonArgs: 'Failed to initialize the hash object.',
        detailArgs: 'Failed to initialize the hash object.',
        adviceArgs: '',
    },
    4026531848: {
        descArgs: 'Failed to initialize the container object.',
        reasonArgs: 'Failed to initialize the container object.',
        detailArgs: 'Failed to initialize the container object.',
        adviceArgs: '',
    },
    4026531849: {
        descArgs: 'Failed to verify the PIN.',
        reasonArgs: 'Failed to verify the PIN.',
        detailArgs: 'Failed to verify the PIN.',
        adviceArgs: '',
    },
    4026531850: {
        descArgs: 'Failed to open the container.',
        reasonArgs: 'Failed to open the container.',
        detailArgs: 'Failed to open the container.',
        adviceArgs: '',
    },
    4026531851: {
        descArgs: 'Failed to generate P10.',
        reasonArgs: 'Failed to generate P10.',
        detailArgs: 'Failed to generate P10.',
        adviceArgs: '',
    },
    4026531852: {
        descArgs: 'Failed to create the container.',
        reasonArgs: 'Failed to create the container.',
        detailArgs: 'Failed to create the container.',
        adviceArgs: '',
    },
    4026531853: {
        descArgs: 'No device is found.',
        reasonArgs: 'No device is found.',
        detailArgs: 'No device is found.',
        adviceArgs: '',
    },
    4026531854: {
        descArgs: 'The application name cannot be empty.',
        reasonArgs: 'The application name cannot be empty.',
        detailArgs: 'The application name cannot be empty.',
        adviceArgs: '',
    },
    4026531855: {
        descArgs: 'Failed to delete the container.',
        reasonArgs: 'Failed to delete the container.',
        detailArgs: 'Failed to delete the container.',
        adviceArgs: '',
    },
    4026531856: {
        descArgs: 'No certificate is found.',
        reasonArgs: 'No certificate is found.',
        detailArgs: 'No certificate found.',
        adviceArgs: '',
    },
    4026531857: {
        descArgs: 'Failed to install the signature certificate .',
        reasonArgs: 'Failed to install the signature certificate .',
        detailArgs: 'Failed to install the signature certificate .',
        adviceArgs: '',
    },
    4026531858: {
        descArgs: 'Failed to install the encryption certificate.',
        reasonArgs: 'Failed to install the encryption certificate.',
        detailArgs: 'Failed to install the encryption certificate.',
        adviceArgs: '',
    },
    4026531859: {
        descArgs: 'The specified container does not exist.',
        reasonArgs: 'The specified container does not exist.',
        detailArgs: 'The specified container does not exist.',
        adviceArgs: '',
    },
    4026531860: {
        descArgs: 'Device authentication failed.',
        reasonArgs: 'The device authentication failed.',
        detailArgs: 'Device authentication failed.',
        adviceArgs: '',
    },
    4026531861: {
        descArgs: 'Failed to create the application.',
        reasonArgs: 'Failed to create the application.',
        detailArgs: 'Failed to create the application.',
        adviceArgs: '',
    },
    4026531863: {
        descArgs: 'The device name is empty.',
        reasonArgs: 'The device name is empty.',
        detailArgs: 'The device name is empty.',
        adviceArgs: '',
    },
    4026531864: {
        descArgs: 'Algorithm not recognized.',
        reasonArgs: 'Algorithm not recognized.',
        detailArgs: 'Algorithm not recognized.',
        adviceArgs: '',
    },
    4026531865: {
        descArgs: 'The device space is insufficient.',
        reasonArgs: 'The device space is insufficient.',
        detailArgs: 'Insufficient device space.',
        adviceArgs: '',
    },
    4026531866: {
        descArgs: 'Parameter error.',
        reasonArgs: 'Parameter error.',
        detailArgs: 'Parameter error.',
        adviceArgs: '',
    },
    4026531867: {
        descArgs: 'The specified device is not matched.',
        reasonArgs: 'The specified device is not matched.',
        detailArgs: 'The specified device is not matched.',
        adviceArgs: '',
    },
    4026531868: {
        descArgs: 'Failed to open the application.',
        reasonArgs: 'Failed to open the application.',
        detailArgs: 'Failed to open the application.',
        adviceArgs: '',
    },
    4026531869: {
        descArgs: 'P7 signature failed.',
        reasonArgs: 'P7 signature failed.',
        detailArgs: 'P7 signature failed.',
        adviceArgs: '',
    },
    4026531870: {
        descArgs: 'Failed to enumerate applications.',
        reasonArgs: 'Failed to enumerate applications.',
        detailArgs: 'Failed to enumerate applications.',
        adviceArgs: '',
    },
    4026532097: {
        descArgs: 'The socket is connected.',
        reasonArgs: 'The socket is connected.',
        detailArgs: 'The socket is connected.',
        adviceArgs: 'Please do not reconnect.',
    },
    4026532098: {
        descArgs: 'The socket fails to be opened.',
        reasonArgs: 'The socket fails to be opened.',
        detailArgs: 'The socket fails to be opened.',
        adviceArgs: 'Please check the network.',
    },
    4026532099: {
        descArgs: 'An error occurs on the Socket server.',
        reasonArgs: 'An error occurs on the Socket server.',
        detailArgs: 'An error occurs on the Socket server.',
        adviceArgs: 'Please try again later.',
    },
};
export { usbKeyErrEn };



// WEBPACK FOOTER //
// ./public/base/utils/i18n/en_US/exception.js